import React, { useContext, useMemo } from 'react';
import useSlideoutDateFilterScope from 'components/PerformanceBoards/hooks/useSlideoutDateFilterScope';
import usePerformanceSlideOutFilterInput from 'components/PerformanceBoards/hooks/usePerformanceSlideOutFilterInput';
import { usePlatesToFilterInput } from 'screens/GoalShow/useGoalData';
import GridSlideoutPreview from './GridSlideout';
import PerformanceBoardSlideOutContext from 'components/PerformanceBoards/contexts/PerformanceBoardSlideOutContext';
import EditingSectionWrapperDiv from '../EditingSectionWrapperDiv';
import getSlideoutDateFilter from '../../getSlideoutDateFilter';

const GridContainer = ({
  section,
}: {
  section: PerformanceBoardTypes.SlideOut.GridSection;
}) => {
  const performanceFilterInput = usePerformanceSlideOutFilterInput({
    datasetForDefaultFiltering: section.dataset,
  });
  const platesToFilterInput = usePlatesToFilterInput();
  // Memoized: legacy docs are normalized into a new object, and an unstable
  // date filter would re-trigger the grid query on every render.
  const dateFilter = useMemo(() => getSlideoutDateFilter(section), [section]);
  const dateScope = useSlideoutDateFilterScope(dateFilter);

  const filters = useMemo((): FilterInput[] | undefined => {
    if (!performanceFilterInput) {
      return undefined;
    }

    if (!section.scope || section.scope.length === 0) {
      return [performanceFilterInput];
    }

    return [performanceFilterInput, platesToFilterInput(section.scope)];
  }, [performanceFilterInput, platesToFilterInput, section.scope]);

  const { navState } = useContext(PerformanceBoardSlideOutContext);

  if (!filters || !dateScope) {
    return null;
  }

  if (navState.slideoutMode === 'Creating' || navState.editingSection) {
    return (
      <EditingSectionWrapperDiv>
        <GridSlideoutPreview
          filters={filters}
          dateScope={dateScope}
          dateField={dateFilter.dateField}
          dataType={section.dataset}
          fields={section.fields}
          noMargin
        />
      </EditingSectionWrapperDiv>
    );
  }

  return (
    <GridSlideoutPreview
      filters={filters}
      dateScope={dateScope}
      dateField={dateFilter.dateField}
      dataType={section.dataset}
      fields={section.fields}
    />
  );
};

export default GridContainer;
